import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { surveyApi } from '../../../api/surveyApi';
import { getDaybyDate, isSuperAndSubAdmin } from '../../../utils/helper';
import DonutChartCard from '../../../component/common/cards/DonutChartCard';
import moment from 'moment';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const options2 = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      grid: {
        drawOnChartArea: false
      }
    },
    y: {
      grid: {
        drawOnChartArea: false
      },
      ticks: {
        beginAtZero: true,
        stepSize: 100,
        callback: function (value) {
          return value % 100 === 0 ? value : '';
        }
      }
    }
  }
};

const ProgressBar = ({ label, percentage }) => (
  <div className="mb-4">
    <div className="flex justify-between items-center mb-1">
      <span className="text-lg font-normal">{label}</span>
      <span className="text-sm text-green-600">{percentage}%</span>
    </div>
    <div className="w-full bg-green-100 rounded-full h-2">
      <div className="bg-green-500 h-2 rounded-full" style={{ width: `${percentage}%` }}></div>
    </div>
  </div>
);

const InsightsShoorahSuperAdmin = ({ InsightsData, userAgeRangeData }) => {

  const dataD = InsightsData?.weeklyUserCount && {
    labels: InsightsData?.weeklyUserCount
      ? InsightsData?.weeklyUserCount.map((item) => getDaybyDate(item.date))
      : [],
    datasets: [
      {
        label: pulseSurveyPageData.insightsPageData.weeklyUsageText,
        data: InsightsData?.weeklyUserCount.map((item) => item.count),
        backgroundColor: 'rgba(74, 87, 218, 1)',
        borderColor: 'rgba(74, 87, 218, 1)',
        borderRadius: 3,
        borderWidth: 1
      }
    ]
  };

  const data = {
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
    datasets: [
      {
        label: pulseSurveyPageData.insightsPageData.surveyMonthlyAnalysisText,
        data: [0, 0, 0, 0, 0, 0],
        backgroundColor: '#2FC9CD',
        borderColor: ' #1F1F1F',
        borderRadius: 3,
        borderWidth: 1
      }
    ]
  };

  const CompletedAssigsmentData = [
    {
      label: pulseSurveyPageData.insightsPageData.completeText,
      value: InsightsData?.completionRate
        ? InsightsData?.completionRate == 'NaN'
          ? 0
          : Number(InsightsData?.completionRate)
        : 0,
      percentage: InsightsData?.completionRate
        ? InsightsData?.completionRate == 'NaN'
          ? 0
          : Number(InsightsData?.completionRate)
        : 0,
      color: '#D97F56'
    },
    {
      label: pulseSurveyPageData.insightsPageData.notCompletedText,
      value: InsightsData?.percentageIncomplete
        ? InsightsData?.percentageIncomplete == 'NaN'
          ? 0
          : Number(InsightsData?.percentageIncomplete)
        : 0,
      percentage: InsightsData?.percentageIncomplete
        ? InsightsData?.percentageIncomplete == 'NaN'
          ? 0
          : Number(InsightsData?.percentageIncomplete)
        : 0,
      color: '#D97F56'
    }
  ];

  const AgeRangeData = [
    {
      label: pulseSurveyPageData.insightsPageData.ageRangeDataLabels.age18To25,
      value: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      percentage: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      color: '#67A14A'
    },
    {
      label: pulseSurveyPageData.insightsPageData.ageRangeDataLabels.age26To32,
      value: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      percentage: userAgeRangeData?.[0]?.percentage
        ? userAgeRangeData?.[0]?.percentage == 'NaN'
          ? 0
          : Number(userAgeRangeData?.[0]?.percentage)
        : 0,
      color: '#C2EC97'
    }
  ];

  const CommonOutComeData = [
    {
      label: pulseSurveyPageData.insightsPageData.commonOutComeDataLabels.anxiety,
      value: 0,
      percentage: 0,
      color: '#F05289'
    },
    {
      label: pulseSurveyPageData.insightsPageData.commonOutComeDataLabels.depression,
      value: 0,
      percentage: 0,
      color: '#FF9BCB'
    }
  ];

  const TopTimeUseData = [
    {
      label: pulseSurveyPageData.insightsPageData.topTimeUseDataLabels.nineToTen,
      value: 0,
      percentage: 0,
      color: '#21BDAD'
    },
    {
      label: pulseSurveyPageData.insightsPageData.topTimeUseDataLabels.sevenToEight,
      value: 0,
      percentage: 0,
      color: '#6BE0BD'
    }
  ];

  const AvrageScoreData = [
    {
      label: pulseSurveyPageData.insightsPageData.averageScoreDataLabels.label1,
      value: InsightsData?.attemptRangeDistribution?.[0]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[0]?.percentage == 'NaN'
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[0]?.percentage)
        : 0,
      percentage: InsightsData?.attemptRangeDistribution?.[0]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[0]?.percentage == 'NaN'
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[0]?.percentage)
        : 0,
      color: '#EDCC12'
    },
    {
      label: pulseSurveyPageData.insightsPageData.averageScoreDataLabels.label2,
      value: InsightsData?.attemptRangeDistribution?.[1]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[1]?.percentage
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[1]?.percentage)
        : 0,
      percentage: InsightsData?.attemptRangeDistribution?.[1]?.percentage
        ? InsightsData?.attemptRangeDistribution?.[1]?.percentage == 'NaN'
          ? 0
          : Number(InsightsData?.attemptRangeDistribution?.[1]?.percentage)
        : 0,
      color: '#FFE873'
    }
  ];

  const insightList = [
    {
      component: (
        <DonutChartCard data={CompletedAssigsmentData} hidePercentage title={pulseSurveyPageData.insightsPageData.usersCompletedTitle} />
      )
    },
    {
      component: <DonutChartCard data={AgeRangeData} hidePercentage title={pulseSurveyPageData.insightsPageData.userAgeRangeTitle} />
    },
    // {
    //   component: (
    //     <div className="p-6 w-full sm:mb-0 lg:w-1/5 min-w-full sm:min-w-[202px] bg-[#FFFFFF] rounded-xl border border-[#E7E8EA] undefined dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder flex flex-col justify-between"></div>
    //   )
    // },
    // {
    //   component: (
    //     <div className="p-6 w-full sm:mb-0 lg:w-1/5 min-w-full sm:min-w-[202px] bg-[#FFFFFF] rounded-xl border border-[#E7E8EA] undefined dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder flex flex-col justify-between"></div>
    //   )
    // },
    {
      component: <DonutChartCard data={CommonOutComeData} hidePercentage title={pulseSurveyPageData.insightsPageData.commonOutComeTitle} />
    },
    {
      component: <DonutChartCard data={TopTimeUseData} hidePercentage title={pulseSurveyPageData.insightsPageData.topUsageTimesTitle} />
    },
    {
      component: <DonutChartCard data={AvrageScoreData} hidePercentage title={pulseSurveyPageData.insightsPageData.averageScoreTitle} />
    }
  ];

  return (
    <div className="w-full mb-10 font-work-sans">
      <div className="flex sm:flex-row flex-col h-auto gap-4 my-5">
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] border-[#E7E8EA] flex items-center p-5 dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#1F1F1F" />
                <path
                  d="M33.98 26.79V30.79C33.98 31.05 33.97 31.3 33.94 31.54C33.71 34.24 32.12 35.58 29.19 35.58H28.79C28.54 35.58 28.3 35.7 28.15 35.9L26.95 37.5C26.42 38.21 25.56 38.21 25.03 37.5L23.83 35.9C23.7 35.73 23.41 35.58 23.19 35.58H22.79C19.6 35.58 18 34.79 18 30.79V26.79C18 23.86 19.35 22.27 22.04 22.04C22.28 22.01 22.53 22 22.79 22H29.19C32.38 22 33.98 23.6 33.98 26.79Z"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M37.98 22.79V26.79C37.98 29.73 36.63 31.31 33.94 31.54C33.97 31.3 33.98 31.05 33.98 30.79V26.79C33.98 23.6 32.38 22 29.19 22H22.79C22.53 22 22.28 22.01 22.04 22.04C22.27 19.35 23.86 18 26.79 18H33.19C36.38 18 37.98 19.6 37.98 22.79Z"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M29.4955 29.25H29.5045"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M25.9955 29.25H26.0045"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M22.4955 29.25H22.5045"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pulseSurveyPageData.insightsPageData.totalResponseText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.totalResponses ? InsightsData?.totalResponses : 0}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA] dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#F05289" />
                <path
                  d="M34.32 28.0002C36.92 28.0002 38 27.0002 37.04 23.7202C36.39 21.5102 34.49 19.6102 32.28 18.9602C29 18.0002 28 19.0802 28 21.6802V24.5602C28 27.0002 29 28.0002 31 28.0002H34.32Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M36.0004 30.6998C35.0704 35.3298 30.6304 38.6898 25.5804 37.8698C21.7904 37.2598 18.7404 34.2098 18.1204 30.4198C17.3104 25.3898 20.6504 20.9498 25.2604 20.0098"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className=" flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pulseSurveyPageData.insightsPageData.completionRateText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.completionRate ? Number(InsightsData.completionRate) : 0}
              </p>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA] dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#0B1D2E" />
                <path
                  d="M36.75 29.25C36.75 34.08 32.83 38 28 38C23.17 38 19.25 34.08 19.25 29.25C19.25 24.42 23.17 20.5 28 20.5C32.83 20.5 36.75 24.42 36.75 29.25Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M28 24V29"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M25 18H31"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight">{pulseSurveyPageData.insightsPageData.timeSpentText}</p>
              <p className="text-[24px] font-medium">00</p>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-3/12 md:w-full h-[96px] bg-[#FFFFFF] rounded-[8px] border-[1.5px] flex items-center pl-3 border-[#E7E8EA] dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder">
          <div className="flex flex-row items-center w-full">
            <div className="flex justify-center items-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="56" height="56" rx="28" fill="#20BDAD" />
                <path
                  d="M33 34.4297H29L24.55 37.3897C23.89 37.8297 23 37.3598 23 36.5598V34.4297C20 34.4297 18 32.4297 18 29.4297V23.4297C18 20.4297 20 18.4297 23 18.4297H33C36 18.4297 38 20.4297 38 23.4297V29.4297C38 32.4297 36 34.4297 33 34.4297Z"
                  stroke="white"
                  strokeWidth="1.5"
                  stroke-miterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.9998 27.3604V27.1504C27.9998 26.4704 28.4198 26.1104 28.8398 25.8204C29.2498 25.5404 29.6598 25.1804 29.6598 24.5204C29.6598 23.6004 28.9198 22.8604 27.9998 22.8604C27.0798 22.8604 26.3398 23.6004 26.3398 24.5204"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M27.9955 29.75H28.0045"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="flex flex-col text-start ml-4">
              <p className="text-[14px] tracking-tight"> {pulseSurveyPageData.insightsPageData.skippedOptionsText}</p>
              <p className="text-[24px] font-medium">
                {InsightsData?.skippedQuestions ? InsightsData?.skippedQuestions : 0}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row md:flex-col gap-10 w-full overflow-x-auto horizontal-card-scrollbar pb-2">

        <div className="md:flex md:flex-row sm:gap-[31px] 2xl:gap-10 w-full">
          {insightList.map((value, key) => (
            <React.Fragment key={key}>{value.component}</React.Fragment>
          ))}
        </div>

      </div>

      <div className="flex flex-col lg:flex-row md:flex-col gap-5 sm:w-full mt-[10px] lg:pb-4 overflow-x-auto horizontal-card-scrollbar">
        <div className=" flex flex-col justify-between w-full md:w-full  lg:max-w-[265px] h-[200px] md:h-[200px] lg:h-[344px] bg-white rounded-xl border-[1.5px] border-[#E7E8EA] p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-shoorah-darkBorder">
          <p className=" text-[20px] lg:text-[20px]  md:text-[25px] leading-tight h-[66px]  font-medium  w-[80%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg">
            {pulseSurveyPageData.insightsPageData.percentageOfIncompleteAssessmentText}
          </p>
          <p className="lg:text-[48px] text-[36px] text-shoorah-lightBlack font-medium dark:text-shoorah-darkBg">
            {InsightsData?.incompletePercentage ? InsightsData?.incompletePercentage : '0'}
          </p>
        </div>

        <div className="h-[344px] max-w-[564px] w-full bg-white rounded-xl border-[1.5px] border-shoorah-borderGray p-5 dark:bg-shoorah-darkBgTabColor dark:text-shoorah-darkBg dark:border-shoorah-darkBorder">
          <div className="flex justify-between w-full items-center mb-1">
            <p className="text-[20px] lg:text-[20px] md:text-[25px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {pulseSurveyPageData.insightsPageData.weeklyUsageText}
            </p>
            <p className="text-[20px] lg:text-[20px] md:text-[25px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {InsightsData?.totalWeeklyUsers || 0} {pulseSurveyPageData.insightsPageData.usersText}
            </p>
          </div>
          <div className="flex justify-between w-full items-center mb-[18px]">
            <p className="text-[14px] leading-5 text-shoorah-lightBlack dark:text-shoorah-darkBg">
              {moment(InsightsData?.weeklyUserCounts?.[0]?.date)?.format('Do')} -{' '}
              {moment(
                InsightsData?.weeklyUserCounts?.[InsightsData?.weeklyUserCounts?.length - 1]?.date
              )?.format('Do MMM, YYYY')}
            </p>
            <p className="text-[16px] font-medium leading-6 text-[#28D9A0]">0%</p>
          </div>
          <Bar
            data={dataD || data}
            options={{
              ...options2
            }}
            className="!h-[222px]"
          />
        </div>
        <div className="flex flex-col min-w-[239px] justify-between w-full md:w-full lg:max-w-[265px] h-[344px] rounded-xl border-[1.5px] border-[#E7E8EA] p-5 bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-none dark:border-shoorah-darkBorder">
          {/* <p className=" text-[20px] lg:text-[20px]  md:text-[25px] leading-tight h-[66px]  font-medium  w-[80%] justify-start text-shoorah-lightBlack dark:text-shoorah-darkBg">
            Drop-off point
          </p>
          <div>
            <div className=" max-w-md lg:max-w-md  mx-auto ">
              <ProgressBar label="Intro" percentage={0} />
              <ProgressBar label="About" percentage={0} />
              <ProgressBar label="Questions" percentage={0} />
            </div>
          </div> */}
        </div>
        <div className="2xl:block hidden flex-col justify-between w-full h-[344px] rounded-xl border-[1.5px] border-shoorah-borderGray bg-shoorah-normanGray dark:bg-shoorah-darkBgColor border-none dark:text-shoorah-darkBg dark:border-shoorah-darkBorder"></div>
      </div>
    </div>
  );
};

export default InsightsShoorahSuperAdmin;
